import { useNavigate, NavLink, Link } from "react-router-dom";
import api from "../../src/services/api";
import { useEffect, useState } from "react";

/* eslint-disable jsx-a11y/anchor-is-valid */
export default function Sidebar() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user")) || { full_name: "" };

  const [permissions, setPermissions] = useState([]);
  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    try {
      const res = await api.get("/users/permissions");
      setPermissions(res.data.data);
    } catch (error) {}
  };
  const logout = async () => {
    try {
      const res = await api.post("/auth/logout");
      if (res.data.success) {
        alert("Bạn đã đăng xuất !");
        localStorage.clear();
        navigate("/login");
      } else {
        alert("Đã có lỗi xảy ra vui lòng thử lại !");
      }
    } catch (error) {}
  };

  return (
    permissions && (
      <div className="w-64 bg-gray-800 text-white flex flex-col h-screen shadow-lg">
        <div className="p-6 text-2xl font-bold border-b border-gray-700">
          <Link to={"/dashboard"}>Admin Panel</Link>
          <br />
          <span className="text-sm font-normal">Chào, {user.full_name} !</span>
        </div>

        <nav className="flex-1 flex flex-col py-4 space-y-1">
          {permissions.includes("blogs.view") && (
            <NavLink
              to="/blogs"
              className={({ isActive }) =>
                `px-6 py-3 text-lg text-left transition-colors duration-200 ${
                  isActive
                    ? "bg-gray-700 text-white font-semibold"
                    : "hover:bg-gray-700 hover:text-white"
                }`
              }
            >
              Quản lý blog
            </NavLink>
          )}
          {permissions.includes("users.view") && (
            <NavLink
              to="/users"
              className={({ isActive }) =>
                `px-6 py-3 text-lg text-left transition-colors duration-200 ${
                  isActive
                    ? "bg-gray-700 text-white font-semibold"
                    : "hover:bg-gray-700 hover:text-white"
                }`
              }
            >
              Quản lý người dùng
            </NavLink>
          )}
        </nav>

        {/* Logout */}
        <div className="p-4 border-t border-gray-700">
          <button
            onClick={async () => {
              await logout();
            }}
            className="w-full px-4 py-2 rounded-md text-white font-semibold transition-colors duration-200 hover:underline"
          >
            Đăng xuất
          </button>
        </div>
      </div>
    )
  );
}
